import { del, extractErrorMessage, get, patch, post } from "src/helpers/api_helper"
import { IConfig, IReportedMessage, IUser, IUsersIndicators, IUserDetail, ResponsePagination, ResponseRequest, IEventNotification } from "./types"

export const getEventsNotification = async (config: IConfig): Promise<ResponseRequest<ResponsePagination<IEventNotification>>> => {
    try {
        let params: any = { ...config }
        if (config?.event_type == 'all') {
            delete params.event_type
        }
        const response = await get<ResponsePagination<IEventNotification>>('/event-notifications', { params })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateEventNotification = async ( id: string ): Promise<ResponseRequest<IEventNotification>> => {
    try {
        const response = await patch<IEventNotification>(`/event-notification/${id}/mark-as-read`, {})
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else {
            return { result: "error", message: response.message }
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}